import { Box, VStack } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";

import { Card } from "adminComponents/atoms/Card";
import { Text } from "adminComponents/atoms/Text";
import { pxToRem } from "adminComponents/utils";
import { IWorkspaceDomain } from "lib/types";

import { AdminFlyout } from "../Flyout";

export interface IProps {
  isOpen: boolean;
  onClose: () => void;
  workspaceDomains?: Array<IWorkspaceDomain>;
}

export const AdminWorkspaceDomainsFlyout: React.FC<IProps> = ({
  isOpen,
  onClose,
  workspaceDomains,
}) => {
  const { t } = useTranslation("admin", {
    useSuspense: false,
    keyPrefix: "districtAdminHomepage.domainsFlyout",
  });
  return (
    <AdminFlyout
      title={t("cta")}
      isOpen={isOpen}
      onClose={onClose}
      subtitle={t("domainsExplanation")}
    >
      <Box paddingBottom={pxToRem(16)} paddingX={pxToRem(24)}>
        <VStack>
          {workspaceDomains?.map((workspaceDomain) => (
            <Card
              variant="adminCardSmallBorder"
              borderColor="primary.tan"
              key={workspaceDomain.id}
            >
              <Text>{workspaceDomain.domain}</Text>
            </Card>
          ))}
        </VStack>
      </Box>
    </AdminFlyout>
  );
};
